module.exports = __webpack_public_path__ + "static/img/14010109.6cf74ab7.png";